import { Spinner } from '@everlywell/ui-kit';
import React, { lazy, Suspense } from 'react';
import { HeroSectionType } from 'utils/types';

const EnterpriseHero = lazy(
  () => import('../../../components/Hero/EnterpriseHero'),
);

export interface HeroContainerProps {
  content: HeroSectionType;
}

export const HeroContainer: React.FC<HeroContainerProps> = ({ content }) => {
  if (!content) {
    return null;
  }

  const { headline, backgroundColor, desktopImage, mobileImage, mainCta } =
    content;

  return (
    <Suspense fallback={<Spinner />}>
      <EnterpriseHero
        headline={headline}
        mainCta={mainCta}
        backgroundColor={backgroundColor}
        backgroundImage={desktopImage.gatsbyImageData}
        mobileBackgroundImage={mobileImage.gatsbyImageData}
        backgroundImageAlt={desktopImage.description}
      />
    </Suspense>
  );
};

export default HeroContainer;
